import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPhoneFormat]',
  standalone:true
})
export class PhoneFormatDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
  let input = this.el.nativeElement.value.replace(/\D/g, ''); // remove all non-digits

  // Limit to 10 digits
  if (input.length > 10) {
  input = input.substring(0, 10);
  }

  // Apply pattern: 050-727-3222
  let formatted = input;
  if (input.length > 3 && input.length <= 6) {
  formatted = `${input.slice(0, 3)}-${input.slice(3)}`;
  } else if (input.length > 6) {
  formatted = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6)}`;
  }

  this.el.nativeElement.value = formatted;
  }
}
